export default "__VITE_ASSET__Bad98Evr__"